import { IBillboardWithImageProps } from '../../shared/components/v2/BillboardWithImage/BillboardWithImage'
import { ModuleBackgroundColors, ModulePadding } from '../../shared/components/v2/ModuleSection/ModuleSection'
import { TEXT_FONT_COLOR, TEXT_FONT_STYLE, TEXT_TAG } from '../../shared/components/v2/Text/TextV2'
import { actionButtonStyle } from '../../shared/components/v2/ActionButton/ActionButton'
import { MobileImageLocation } from '../../shared/components/v2/BillboardWithImage/BillboardImage'
import { IFaqBlockProps } from '../../shared/components/v2/FaqBlock/FaqBlock'

export const securityHeroBillboardWithImageProps: IBillboardWithImageProps = {
  moduleBackgroundColor: {
    desktop: ModuleBackgroundColors.white,
    mobile: ModuleBackgroundColors.white,
  },
  modulePadding: { top: ModulePadding.XL, bottom: ModulePadding.XL },
  mobileModulePadding: { top: ModulePadding.XL, bottom: ModulePadding.XL },
  dataTestId: 'security-hero-billboard-with-image',
  billboardImage: {
    src: '/static/v2/security-page/security-hero.png',
    alt: 'Phone, NorthOne Card, and security icons',
    sx: {
      display: ['none', 'none', 'inline'],
    },
  },

  title: {
    tag: TEXT_TAG.h1,
    text: 'Security',
    textFontStyle: TEXT_FONT_STYLE.h1,
    textFontColor: TEXT_FONT_COLOR.blackPrimary,
  },
  body: [
    {
      tag: TEXT_TAG.p,
      text:
        'Keeping your money and information safe is hugely important to us. We secure your account and personal information with biometric authentication, and fraud monitoring so you can rest easy, knowing you’re protected.',
      textFontStyle: TEXT_FONT_STYLE.bodyXlargeLight,
      textFontColor: TEXT_FONT_COLOR.blackPrimary,
    },
  ],

  actionButton: {
    body: {
      text: 'Apply for an Account',
      tag: TEXT_TAG.p,
      textFontStyle: TEXT_FONT_STYLE.bodyMediumBold,
      textFontColor: TEXT_FONT_COLOR.white,
    },
    link: 'https://join.northone.com/',
    buttonStyle: actionButtonStyle.blackPrimary,
  },
}

const headingBodySx = {
  paddingBottom: '18px',
}
export const securityCardFreezeBillboardWithImageProps: IBillboardWithImageProps = {
  moduleBackgroundColor: {
    desktop: ModuleBackgroundColors.goldTint4,
    mobile: ModuleBackgroundColors.goldTint4,
  },
  modulePadding: { top: ModulePadding.MD, bottom: ModulePadding.MD },
  mobileModulePadding: { top: ModulePadding.MD, bottom: ModulePadding.NONE },
  dataTestId: 'security-card-freeze-billboard-with-image',
  copyLocation: 'right',
  billboardImage: {
    src: '/static/v2/security-page/security-cardfreeze.png',
    mobileSrc: '/static/v2/security-page/security-cardfreeze-mobile.png',
    alt: 'Locked NorthOne card floating over phone',
    mobileImageLocation: MobileImageLocation.BOTTOM,
  },

  title: {
    tag: TEXT_TAG.h2,
    text: '320,000+ businesses trust NorthOne to keep their money safe',
    textFontStyle: TEXT_FONT_STYLE.h2,
    textFontColor: TEXT_FONT_COLOR.blackPrimary,
    sx: {
      width: ['auto', 'auto', '500px'],
    },
  },
  headingList: [
    {
      iconSrc: '/static/v2/security-page/security-security-icon.svg',
      iconAlt: 'Blue shield with check mark',
      iconColor: TEXT_FONT_COLOR.blackPrimary,
      title: {
        text: 'Funds in the Account are FDIC insured to at least $250,000 through The Bancorp Bank, N.A., Member FDIC',
        tag: TEXT_TAG.p,
        textFontStyle: TEXT_FONT_STYLE.bodyLargeBold,
        textFontColor: TEXT_FONT_COLOR.blackPrimary,
      },
      body: {
        tag: TEXT_TAG.p,
        text: 'Banking services provided by The Bancorp Bank, N.A., Member FDIC.',
        textFontStyle: TEXT_FONT_STYLE.bodyLargeLight,
        textFontColor: TEXT_FONT_COLOR.blackPrimary,
        sx: headingBodySx,
      },
    },
    {
      iconSrc: '/static/v2/security-page/security-freeze-icon.svg',
      iconAlt: 'Blue shield with check mark',
      iconColor: TEXT_FONT_COLOR.blackPrimary,
      title: {
        text: 'Freeze your card',
        tag: TEXT_TAG.p,
        textFontStyle: TEXT_FONT_STYLE.bodyLargeBold,
        textFontColor: TEXT_FONT_COLOR.blackPrimary,
      },
      body: {
        tag: TEXT_TAG.p,
        text: 'If your card is lost or stolen lock all account activity and order a new card in seconds.',
        textFontStyle: TEXT_FONT_STYLE.bodyLargeLight,
        textFontColor: TEXT_FONT_COLOR.blackPrimary,
        sx: headingBodySx,
      },
    },

    {
      iconSrc: '/static/v2/security-page/security-biometrics-icon.svg',
      iconAlt: 'Biometric security',
      iconColor: TEXT_FONT_COLOR.blackPrimary,
      title: {
        text: 'Biometric security',
        tag: TEXT_TAG.p,
        textFontStyle: TEXT_FONT_STYLE.bodyLargeBold,
        textFontColor: TEXT_FONT_COLOR.blackPrimary,
      },
      body: {
        tag: TEXT_TAG.p,
        text: 'Use Touch ID™ or Face ID™ to log in send payments, and view sensitive details.',
        textFontStyle: TEXT_FONT_STYLE.bodyLargeLight,
        textFontColor: TEXT_FONT_COLOR.blackPrimary,
        sx: headingBodySx,
      },
    },
  ],
}

export const securityFaqBlockData: IFaqBlockProps = {
  moduleBackgroundColor: {
    desktop: ModuleBackgroundColors.copperDark,
    mobile: ModuleBackgroundColors.copperDark,
  },
  modulePadding: { top: ModulePadding.L, bottom: ModulePadding.L },
  dataTestId: 'security-faq-block',
  title: {
    tag: TEXT_TAG.h2,
    text: 'Security FAQ',
    textFontStyle: TEXT_FONT_STYLE.h2,
    textFontColor: TEXT_FONT_COLOR.white,
  },
  body: [
    {
      question: {
        tag: TEXT_TAG.p,
        text: 'Is my account insured?',
        textFontStyle: TEXT_FONT_STYLE.bodyXlargeSemibold,
        textFontColor: TEXT_FONT_COLOR.white,
      },
      answer: {
        tag: TEXT_TAG.p,
        text:
          'All accounts opened with NorthOne are FDIC insured. Banking services are provided by The Bancorp Bank, N.A., Member FDIC. That means your deposits are federally protected for up to $250,000 against bank failure or theft.',
        textFontStyle: TEXT_FONT_STYLE.bodyLargeLight,
        textFontColor: TEXT_FONT_COLOR.white,
      },
      isOpen: false,
    },

    {
      question: {
        tag: TEXT_TAG.p,
        text: 'What is The Bancorp Bank, N.A.?',
        textFontStyle: TEXT_FONT_STYLE.bodyXlargeSemibold,
        textFontColor: TEXT_FONT_COLOR.white,
      },
      answer: {
        tag: TEXT_TAG.p,
        text:
          'NorthOne is partnered with The Bancorp Bank, N.A., a federally-chartered bank and member of the FDIC. The Bancorp Bank, N.A. has built out powerful API-driven technology to support quick digital account opening and other self-serve features that empower small business owners.',
        textFontStyle: TEXT_FONT_STYLE.bodyLargeLight,
        textFontColor: TEXT_FONT_COLOR.white,
      },
      isOpen: false,
    },

    {
      question: {
        tag: TEXT_TAG.p,
        text: 'What do I do if my debit card was lost or stolen?',
        textFontStyle: TEXT_FONT_STYLE.bodyXlargeSemibold,
        textFontColor: TEXT_FONT_COLOR.white,
      },
      answer: {
        tag: TEXT_TAG.p,
        text:
          'All you need to do is contact our support team through the NorthOne app. New cards are usually delivered within 5 business days.',
        textFontStyle: TEXT_FONT_STYLE.bodyLargeLight,
        textFontColor: TEXT_FONT_COLOR.white,
      },
      isOpen: false,
    },

    {
      question: {
        tag: TEXT_TAG.p,
        text: 'Is my personal information safe?',
        textFontStyle: TEXT_FONT_STYLE.bodyXlargeSemibold,
        textFontColor: TEXT_FONT_COLOR.white,
      },
      answer: {
        tag: TEXT_TAG.p,
        text:
          'Yes. We take privacy very seriously. We never store or maintain any sensitive personal information, and will only communicate with you through secure channels.',
        textFontStyle: TEXT_FONT_STYLE.bodyLargeLight,
        textFontColor: TEXT_FONT_COLOR.white,
      },
      isOpen: false,
    },

    {
      question: {
        tag: TEXT_TAG.p,
        text: 'Is mobile banking safe?',
        textFontStyle: TEXT_FONT_STYLE.bodyXlargeSemibold,
        textFontColor: TEXT_FONT_COLOR.white,
      },
      answer: {
        tag: TEXT_TAG.p,
        text:
          'Yes. We protect your account with multi-factor authentication, constantly monitor transactions for any suspicious activities, and will notify you immediately if there’s anything to be concerned with. Plus, your account is FDIC-insured. Banking services are provided by The Bancorp Bank, N.A., Member FDIC.',
        textFontStyle: TEXT_FONT_STYLE.bodyLargeLight,
        textFontColor: TEXT_FONT_COLOR.white,
      },
      isOpen: false,
    },
  ],
}
